export const EDITTING_DOCUMENTS = 'scenes/VehicleDetail/components/Data/editting_documents'
export const EDITTING_DATA = 'scenes/VehicleDetail/components/Data/editting_data'



// WEBPACK FOOTER //
// ./src/scenes/VehicleDetail/components/Data/constants.js